import { Component, OnInit, OnDestroy } from '@angular/core';
import { InitService } from 'src/app/services/init.service';
import { interval, Subscription } from 'rxjs';
import { first } from 'rxjs/operators';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    standalone: false
})
export class ErrorComponent implements OnInit, OnDestroy {
  public retrying: boolean = false;
  public retryCount: number = 0;
  private retrySubscription: Subscription;

  constructor(private initService: InitService) {}

  ngOnInit(): void {
    this.startRetrying();
  }

  ngOnDestroy(): void {
    if (this.retrySubscription) {
      this.retrySubscription.unsubscribe();
    }
  }

  startRetrying(): void {
    this.retrying = true;
    // Retry every 5 seconds
    this.retrySubscription = interval(5000).subscribe(() => {
      this.retryCount++;
      this.initService.ping().pipe(first()).subscribe({
        next: () => {
          // API is back, reload the page
          window.location.href = '/';
        },
        error: () => {
          // Still down, keep retrying
        }
      });
    });
  }

  manualRetry(): void {
    this.initService.ping().pipe(first()).subscribe({
      next: () => {
        window.location.href = '/';
      },
      error: () => {
        // Still down
      }
    });
  }
}
